var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85.33 170.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);}.cls-2,.cls-24,.cls-26,.cls-4,.cls-6,.cls-8{mix-blend-mode:multiply;}.cls-2{fill:url(#linear-gradient);}.cls-3{mask:url(#mask-2);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{mask:url(#mask-3);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{mask:url(#mask-4);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{isolation:isolate;}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-6);}.cls-12{fill:#e6e6e6;}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:#a3472b;}.cls-15,.cls-16,.cls-17,.cls-27,.cls-32{fill:#6a6a6a;}.cls-15,.cls-16,.cls-17,.cls-21,.cls-27,.cls-31,.cls-32{mix-blend-mode:color-burn;}.cls-15,.cls-24,.cls-26{opacity:0.3;}.cls-16{opacity:0.7;}.cls-17{opacity:0.4;}.cls-18{fill:#e36b3c;}.cls-19{fill:#ba5131;}.cls-20{fill:#691c0a;}.cls-21{fill:#d93c14;}.cls-21,.cls-31,.cls-32{opacity:0.2;}.cls-22{fill:#96280f;}.cls-23{mask:url(#mask-5);}.cls-24{fill:url(#linear-gradient-8);}.cls-25{mask:url(#mask-6);}.cls-26{fill:url(#linear-gradient-9);}.cls-27{opacity:0.6;}.cls-28{fill:url(#linear-gradient-10);}.cls-29{fill:url(#linear-gradient-11);}.cls-30{fill:url(#linear-gradient-12);}.cls-31{fill:#959595;}.cls-33{mask:url(#mask-7);}.cls-34,.cls-36{mix-blend-mode:soft-light;opacity:0.8;}.cls-34{fill:url(#linear-gradient-13);}.cls-35{mask:url(#mask-8);}.cls-36{fill:url(#linear-gradient-14);}.cls-37{filter:url(#luminosity-noclip-8);}.cls-38{filter:url(#luminosity-noclip-7);}.cls-39{filter:url(#luminosity-noclip-6);}.cls-40{filter:url(#luminosity-noclip-5);}.cls-41{filter:url(#luminosity-noclip-4);}.cls-42{filter:url(#luminosity-noclip-3);}.cls-43{filter:url(#luminosity-noclip-2);}.cls-44{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 3126.52,
    y: -8417,
    width: 77.06,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 3126.52,
    y: -8417,
    width: 77.06,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3135.21,
    y1: 225.4,
    x2: 3194.57,
    y2: 177.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 3126.52,
    y: -8417,
    width: 77.07,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 3126.52,
    y: -8417,
    width: 77.07,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3168.78,
    y1: 162.82,
    x2: 3161.3,
    y2: 239.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 3124.52,
    y: -8417,
    width: 70,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 3124.52,
    y: -8417,
    width: 70,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3189.31,
    y1: 232.94,
    x2: 3132.19,
    y2: 181.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 3132.31,
    y: -8417,
    width: 67.69,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 3132.31,
    y: -8417,
    width: 67.69,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 3188.72,
    y1: 218.33,
    x2: 3148.67,
    y2: 179.48,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -2053.98,
    y1: 106.12,
    x2: -2156.93,
    y2: -63.98,
    gradientTransform: "matrix(-1, 0, 0, 1, -2012.48, -71.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003d14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 53.09,
    y1: 79.09,
    x2: -23.9,
    y2: -59.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c8c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2052.26,
    y1: 93.78,
    x2: -2156.32,
    y2: -78.16,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 3126.52,
    y: 162.64,
    width: 77.06,
    height: 77.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 5.5,
    y: 90.89,
    width: 77.06,
    height: 77.06,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3121.02 -71.75)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3165.05,239.71a38.54,38.54,0,1,1,38.53-38.54A38.58,38.58,0,0,1,3165.05,239.71Z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 3135.21,
    y1: 225.4,
    x2: 3194.57,
    y2: 177.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e5e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#d0b1bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#bd849b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ad5e7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#a13e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#972653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#901546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8b0b3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a083c"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 3126.52,
    y: 162.65,
    width: 77.07,
    height: 77.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 5.5,
    y: 90.9,
    width: 77.07,
    height: 77.06,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3121.02 -71.75)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3203.58,201.18a38.53,38.53,0,0,1-73.9,15.27,38.13,38.13,0,0,1-3.16-15.27,38.53,38.53,0,0,1,77.06,0Z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 3168.78,
    y1: 162.82,
    x2: 3161.3,
    y2: 239.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 98.14,
    y1: -32.69,
    x2: 33.43,
    y2: 67.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 41.78,
    y1: 42.86,
    x2: 79.22,
    y2: 42.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c8c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 106.3,
    y1: -32.4,
    x2: 41.33,
    y2: 67.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 3124.52,
    y: 174.71,
    width: 70,
    height: 61.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 3.5,
    y: 102.96,
    width: 70,
    height: 61.32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3121.02 -71.75)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M3194.52,230.09a41.41,41.41,0,0,1-7.31,5.93l-.47-1.83-.25-1-2.15.26-5.07-4.59-50-42-1.12-4.24-3.66,1.2a8.36,8.36,0,0,0,.51-1.16c.31-.67.64-1.34,1-2a39.6,39.6,0,0,1,3-4.83l4.34-1.08.22,4.25,48.4,39.77,1.36,1.24v0h0l1.92,1.75,2.71,2.45h0l2.6,2.37.32.27.43.4h2l.16.43Z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 3189.31,
    y1: 232.94,
    x2: 3132.19,
    y2: 181.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 3132.31,
    y: 168.57,
    width: 67.69,
    height: 58.41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 11.3,
    y: 96.82,
    width: 67.69,
    height: 58.41,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3121.02 -71.75)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3200,223.18a37.63,37.63,0,0,1-2.73,3.8l-1.12-2.91-.05-.12h-2.16l-57.34-48.74-.42-3.56-3.87.15.44-.46c.48-.5,1-1,1.48-1.45.36-.34.74-.68,1.12-1l4.37-.33,0,3.46,56,47.25.7.65,2.06-.07h.27Z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 3188.72,
    y1: 218.33,
    x2: 3148.67,
    y2: 179.48,
    xlinkHref: "#linear-gradient-13"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "24.86 0 44.95 85.73 47.86 85.73 30.08 0 24.86 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "18.84 0 41.12 85.73 44.95 85.73 24.86 0 18.84 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "13.23 0 38.47 85.73 41.12 85.73 18.84 0 13.23 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "13.23 0 38.47 85.73 41.12 85.73 18.84 0 13.23 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M3199.6,185.8v0a43.15,43.15,0,0,0-5.94-10.38s0,0,0,0c-.17-.21-.32-.41-.5-.62l-.08-.09a41.16,41.16,0,0,0-20.38-13.57c-.3-.1-.59-.17-.9-.25l-1.55-.4.45,0h.36l.61,0h.8c0-.05.06-.36.11-.87a12.93,12.93,0,0,0-1.52-5h0s0,0,0,0a6,6,0,0,0-.53-.86s0,0,0-.07a7.29,7.29,0,0,0-6.29-2.95c-2.38,0-5.51.81-7.08,2.43-3.18,3.27-3.47,5.41-3.48,7v.05a39,39,0,0,0-15.76,6.76c-.87.63-1.7,1.29-2.52,2-.38.32-.76.66-1.12,1-.51.48-1,.95-1.48,1.45l-.44.46h0c-.32.34-.64.69-1,1.06-.81.93-1.58,1.9-2.31,2.92a39.6,39.6,0,0,0-3,4.83c-.34.65-.67,1.32-1,2-.18.39-.35.77-.51,1.16a44.08,44.08,0,0,0-3.5,17.39c0,19,12.95,34.09,30.18,38.92a43.59,43.59,0,0,0,11.88,1.65,39.62,39.62,0,0,0,22.79-6.91c.3-.21.59-.41.87-.63a35.73,35.73,0,0,0,6.08-5.64c.26-.28.5-.58.74-.88.64-.77,1.25-1.58,1.81-2.41.27-.39.54-.79.78-1.19s.52-.82.76-1.25l.08-.13c.28-.48.56-1,.82-1.49s.45-.88.66-1.34a43.22,43.22,0,0,0,4-18.56A42.38,42.38,0,0,0,3199.6,185.8Zm-42.12-29.14c.16-.77.38-.4.7-.17s.49.27.8-.2a6.54,6.54,0,0,1,.61-.76,4.61,4.61,0,0,1,3.47-1.37,4.82,4.82,0,0,1,2.12.44,3.59,3.59,0,0,1,.71.42,2.39,2.39,0,0,1,.22.16c.13.1,2.94,2.47,2.85,4.14l-.41-.06a27.76,27.76,0,0,0-7.51-.16c-.83.08-1.6.21-2.37.33l-1.07.15-.5,0A16,16,0,0,1,3157.48,156.66Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M3170.85,160.46s-2-1.16-1.89-1.13c.08-1.68-2.72-4.05-2.86-4.15a3.8,3.8,0,0,0-.91-.58,3.82,3.82,0,0,1,2,.12l.45.46C3168.74,156.87,3171.81,157.93,3170.85,160.46Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3172.9,163.45h-4.22l-10.14.51-.94-4.37c1.15-.15,2.23-.36,3.44-.48a27.26,27.26,0,0,1,7.92.22s3,1.94,3,2.05C3172.58,162.76,3172.87,163.44,3172.9,163.45Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M3171,154.61h0a38.28,38.28,0,0,1-3.77-1.1l-6.63.91-1,.13-.68,1.73-.81.2-.7.17-1.85,4.71-.52-.33-1.47-.94c0-1.55.3-3.69,3.48-7a7.53,7.53,0,0,1,2.67-1.63,13.24,13.24,0,0,1,4.41-.8,7.66,7.66,0,0,1,5.35,1.87,5.84,5.84,0,0,1,.94,1.08,8.92,8.92,0,0,1,.54.92S3171,154.61,3171,154.61Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M3173.91,160.84a8.47,8.47,0,0,0-1.79-5.23,17.16,17.16,0,0,0-1.64-2,7.82,7.82,0,0,0-6-2.2,8.54,8.54,0,0,0-3.66.78h0a8.39,8.39,0,0,0-2.28,1.65c-3.31,3.41-3.47,6-3.47,7.15v.06a41.29,41.29,0,0,0-18.92,10.56,40.29,40.29,0,0,0-2.81,3,41.28,41.28,0,0,0,61.15,55.38,35,35,0,0,0,2.75-3.1,39.27,39.27,0,0,0,2.73-3.8,41.31,41.31,0,0,0-26.09-62.34Zm-8.86-1a40.8,40.8,0,0,0-6.49.51,5.2,5.2,0,0,1,.11-1c.19-1,.66-1.41,1.7-2.44q.32-.3.69-.69a4.54,4.54,0,0,1,3.46-1.38,8.52,8.52,0,0,1,1.37.09,3.58,3.58,0,0,1,2.12,1,16.4,16.4,0,0,1,1.15,1.29,5.57,5.57,0,0,1,1.28,2.91A43.57,43.57,0,0,0,3165.05,159.89Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M3172.12,155.61l-3,1.72A16.4,16.4,0,0,0,3168,156a3.58,3.58,0,0,0-2.12-1,8.52,8.52,0,0,0-1.37-.09,4.54,4.54,0,0,0-3.46,1.38q-.37.39-.69.69l.26-2.56.22-2.19h0a8.32,8.32,0,0,0-1.08-.73,13.24,13.24,0,0,1,4.41-.8,7.66,7.66,0,0,1,5.35,1.87c.3.36.6.73.94,1.08A17.16,17.16,0,0,1,3172.12,155.61Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M3165.05,239.71a38.54,38.54,0,1,1,38.53-38.54A38.58,38.58,0,0,1,3165.05,239.71Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3174.27,197.23a13.51,13.51,0,0,0-1.46-.34v-.38a16.48,16.48,0,0,0,3.05-1.16,11.36,11.36,0,0,0,2.9-2,8.33,8.33,0,0,0,2.66-6.2,8.83,8.83,0,0,0-4.12-7.09c-2.66-1.77-6.14-2.34-10.89-2.34a36.39,36.39,0,0,0-12.54,2c0,.33-1.44,1.49-1.46,1.82-.21,3,1.07,5.29,1,8.32a5.85,5.85,0,0,1,2.45,1.33,4.91,4.91,0,0,0,2.42,1.18c.23,0,1.25-1.84,1.47-1.81l1.14-4.92.19-.79a.68.68,0,0,1,.31-.5l.14-.1a6.23,6.23,0,0,1,3.41-.85c1.84,0,3.36.19,4.56,1.52a4.75,4.75,0,0,1,1.21,3.36,5.42,5.42,0,0,1-2,4.57c-1.76,1.4-4.88,2.23-10.07,2.27,0,.26-1.47,1.53-1.47,1.81,0,1.64,1.55,2.45,1.66,4.08h3.54c5.07,0,8.75,2.15,8.75,6.46a6.26,6.26,0,0,1-.78,3.12,5.26,5.26,0,0,1-1.06,1.31l-.25.21a8.7,8.7,0,0,1-5.39,1.44,7.07,7.07,0,0,1-2.72-.57.89.89,0,0,1-.45-.57l-1.45-5.95-.22,0c-2.16.31-4.41.67-6.37,1,0,.32-1.5,1.49-1.47,1.81.36,3.3,2.34,5.8,2.8,9.15a45.12,45.12,0,0,0,8.61.69c6.66,0,11.91-1.13,14.76-3.29.45-.33.88-.67,1.3-1s.63-.57.93-.88a10.25,10.25,0,0,0,3.09-7.52C3182.37,202.65,3179.79,198.75,3174.27,197.23Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M3161.48,184.25l-.14.1a.68.68,0,0,0-.31.5l-.19.79-1.14,4.92c-.22,0-1.24,1.83-1.47,1.81a4.91,4.91,0,0,1-2.42-1.18c.74-2.73,3.17-6.23,4.45-6.8l1.17-.21Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M3182.37,206.46a10.25,10.25,0,0,1-3.09,7.52c-.3.31-.61.6-.93.88-.81-1.52-.56-3.18-.29-4.78.66-3.82-3-6.08-5.69-8.08-1.2-.9-2.78-2.08-2.33-3.79a3.28,3.28,0,0,1,2.14-2.13,17,17,0,0,1,3.68-.73,16.48,16.48,0,0,1-3.05,1.16v.38a13.51,13.51,0,0,1,1.46.34C3179.79,198.75,3182.37,202.65,3182.37,206.46Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M3170.52,212c-.15,4.49-5.53,6.49-9.28,5.79-1.39-.26-3.7-.83-4.51-2.15-.52-.84-.09-1.71,0-2.61.24-1.72-.43-3.48.61-4.78a1.93,1.93,0,0,1,.31-.33,7.58,7.58,0,0,0,1-1.46l.22,0,1.45,5.95a.89.89,0,0,0,.45.57,7.07,7.07,0,0,0,2.72.57,8.7,8.7,0,0,0,5.39-1.44l.25-.21a5.26,5.26,0,0,0,1.06-1.31A3.78,3.78,0,0,1,3170.52,212Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3171.34,198.7v-.38a16.92,16.92,0,0,0,2.93-1.09,10.52,10.52,0,0,0,4.49-3.9A8.33,8.33,0,0,0,3180,189a8.83,8.83,0,0,0-4.12-7.1c-2.66-1.77-6.15-2.34-10.89-2.34a36,36,0,0,0-12.54,2c-.26,3.29-.38,6.77-.51,10.13,2,.32,4.24.51,6.33.7l1.33-5.7a.74.74,0,0,1,.32-.51,3.82,3.82,0,0,1,1-.52,7.29,7.29,0,0,1,2.59-.43c1.83,0,3.35.19,4.56,1.52a4.82,4.82,0,0,1,1.2,3.36,6.29,6.29,0,0,1-.56,2.76c-1.16,2.46-4.38,4-11.54,4.08,0,1.83.07,4,.19,5.89h3.55c5.07,0,8.74,2.15,8.74,6.46a6.44,6.44,0,0,1-.62,2.83,5.09,5.09,0,0,1-1.22,1.6c-1.2,1.08-3.1,1.65-5.63,1.65a7.13,7.13,0,0,1-2.73-.57.83.83,0,0,1-.44-.57l-1.46-5.95h-.09c-2.19.31-4.5.69-6.5,1.06.38,3.61.83,7.29,1.33,11a45.19,45.19,0,0,0,8.62.7c6.65,0,11.91-1.14,14.76-3.29a14.86,14.86,0,0,0,3.69-3.73,10.16,10.16,0,0,0,1.63-5.71C3180.91,204.15,3177.87,199.91,3171.34,198.7Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M3165.05,239.71a38.54,38.54,0,1,1,38.53-38.54A38.58,38.58,0,0,1,3165.05,239.71Z",
    transform: "translate(-3121.02 -71.75)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M3203.58,201.18a38.53,38.53,0,0,1-73.9,15.27,38.13,38.13,0,0,1-3.16-15.27,38.53,38.53,0,0,1,77.06,0Z",
    transform: "translate(-3121.02 -71.75)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M3203.58,201.18a38.58,38.58,0,0,1-36.91,38.49c19.69-1.69,34.35-18.26,34.35-38.38,0-21.25-16.45-38.53-37.7-38.53-.59,0-1.16,0-1.75,0,1.15-.1,2.3-.16,3.48-.16A38.57,38.57,0,0,1,3203.58,201.18Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3196.41,217.88s-1.1,2.72-2.59,3.46a3.8,3.8,0,0,1-2,.42h0a1.5,1.5,0,0,1-1.35-.91c-.37-1,.53-2.45,2-3.19a3.23,3.23,0,0,1,1.12-.27A7.78,7.78,0,0,1,3196.41,217.88Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3188.44,220.16a1.11,1.11,0,0,1-1,.2,3.86,3.86,0,0,1-2.12-1.83c-.8-1.31-.71-3.66-.67-4.33,0-.12,0-.19,0-.19s2.51.66,3.45,2.21S3189.21,219.52,3188.44,220.16Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3192.37,225s-1.48,2.46-3.06,2.89a3.83,3.83,0,0,1-1.36.13,1.89,1.89,0,0,1-1.89-1.31c-.22-1.07.89-2.29,2.47-2.72a2.2,2.2,0,0,1,.37-.06A6.79,6.79,0,0,1,3192.37,225Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3183.51,226a1,1,0,0,1-.53,0c-.77-.25-1.51-1.38-1.8-2.87a8.16,8.16,0,0,1,.69-4.08c.1-.24.17-.39.17-.39s2.1,1.72,2.47,3.57S3184.43,225.71,3183.51,226Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3199.41,208.58s-.66,2.9-2,3.94a3.46,3.46,0,0,1-2.44.83,1.28,1.28,0,0,1-1-.61c-.52-.93.16-2.52,1.51-3.56a4.1,4.1,0,0,1,2.33-.68h0A8.07,8.07,0,0,1,3199.41,208.58Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3192.39,212.67a1.39,1.39,0,0,1-1.46.55,4,4,0,0,1-1.93-.93c-1.31-1.1-1.87-4-1.87-4l.49,0h.11a5.13,5.13,0,0,1,3.27.82C3192.32,210.15,3192.94,211.77,3192.39,212.67Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3196.09,193.3c-.59,1.65-1.73,2.69-2.58,2.42h0a.35.35,0,0,1-.13-.05c-.87-.43-1.06-2.19-.43-3.93a6.42,6.42,0,0,1,2.45-2.71c.31-.2.51-.31.51-.31S3196.73,191.56,3196.09,193.3Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3192.14,196.46a1.72,1.72,0,0,1-1.93.92,3.89,3.89,0,0,1-1.44-.41c-1.49-.74-2.59-3.46-2.59-3.46a8,8,0,0,1,2.24-.49,3.34,3.34,0,0,1,1.69.27C3191.6,194,3192.51,195.44,3192.14,196.46Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3198,203.06c-.84,1.19-1.93,1.82-2.71,1.64a1,1,0,0,1-.48-.25c-.73-.7-.49-2.45.53-3.92a5.68,5.68,0,0,1,3-1.79c.35-.1.59-.15.59-.15S3199,201.59,3198,203.06Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3192.65,204.39a1.56,1.56,0,0,1-1.71.73,3.86,3.86,0,0,1-1.69-.64c-1.42-.91-2.27-3.75-2.27-3.75a9,9,0,0,1,1.52-.22h.05a4.17,4.17,0,0,1,2.36.47C3192.33,201.9,3193.11,203.43,3192.65,204.39Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3192.62,184.3c-.31,1.62-1.22,2.75-2,2.54,0,0-.06,0-.08,0-.76-.29-1.11-1.72-.82-3.28a6.14,6.14,0,0,1,1.73-2.75l.42-.39A7.88,7.88,0,0,1,3192.62,184.3Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3190,189c-.16.8-1.09,1.25-2.21,1.16a5.22,5.22,0,0,1-.63-.11c-1.38-.37-2.69-2.51-2.69-2.51a6.76,6.76,0,0,1,2.52-.95,2.1,2.1,0,0,1,.83,0C3189.24,187,3190.21,188.05,3190,189Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3188.19,178c-.08,1.44-.72,2.55-1.44,2.5a.78.78,0,0,1-.25-.07c-.58-.28-1-1.36-.9-2.62a5.55,5.55,0,0,1,1.14-2.61c.19-.27.33-.43.33-.43A6.63,6.63,0,0,1,3188.19,178Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3186.81,182.79c0,.84-1.07,1.44-2.31,1.35h-.05a5.25,5.25,0,0,1-2.54-1.72,5.73,5.73,0,0,1,2.35-1.29,1.91,1.91,0,0,1,.41,0C3185.9,181.2,3186.86,182,3186.81,182.79Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3184.39,178.45a1.17,1.17,0,0,1-1.32.5,3.08,3.08,0,0,1-1.26-.53c-1.06-.74-1.64-2.91-1.64-2.91a5.47,5.47,0,0,1,.93-.11,3.33,3.33,0,0,1,2,.41C3184.2,176.55,3184.77,177.73,3184.39,178.45Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3195.81,217.88s-1.09,2.72-2.58,3.46a4,4,0,0,1-1.43.42h0a1.5,1.5,0,0,1-1.35-.91c-.37-1,.53-2.45,2-3.19a3.23,3.23,0,0,1,1.12-.27A8.29,8.29,0,0,1,3195.81,217.88Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3187.85,220.16a.91.91,0,0,1-.39.2,3.86,3.86,0,0,1-2.12-1.83c-.8-1.31-.71-3.66-.67-4.33a5.8,5.8,0,0,1,2.87,2C3188.48,217.75,3188.62,219.52,3187.85,220.16Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3191.78,225s-1.48,2.46-3.06,2.89a4.43,4.43,0,0,1-.77.13,1.89,1.89,0,0,1-1.89-1.31c-.22-1.07.89-2.29,2.47-2.72a2.2,2.2,0,0,1,.37-.06A7.74,7.74,0,0,1,3191.78,225Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3183,226c-.77-.25-1.51-1.38-1.8-2.87a8.16,8.16,0,0,1,.69-4.08,6.82,6.82,0,0,1,2.05,3.18C3184.28,224,3183.86,225.64,3183,226Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3198.82,208.58s-.66,2.9-2,3.94a3.88,3.88,0,0,1-1.85.83,1.28,1.28,0,0,1-1-.61c-.52-.93.16-2.52,1.51-3.56a4.1,4.1,0,0,1,2.33-.68h0A6.93,6.93,0,0,1,3198.82,208.58Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3191.8,212.67a1.21,1.21,0,0,1-.87.55,4,4,0,0,1-1.93-.93c-1.31-1.1-1.87-4-1.87-4l.49,0h.11a4.7,4.7,0,0,1,2.69.82C3191.73,210.15,3192.35,211.77,3191.8,212.67Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3195.5,193.3a3.74,3.74,0,0,1-2,2.42h0a.35.35,0,0,1-.13-.05c-.87-.43-1.06-2.19-.43-3.93a6.42,6.42,0,0,1,2.45-2.71A8.55,8.55,0,0,1,3195.5,193.3Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3191.55,196.46a1.51,1.51,0,0,1-1.34.92,3.89,3.89,0,0,1-1.44-.41c-1.49-.74-2.59-3.46-2.59-3.46a8,8,0,0,1,2.24-.49,2.7,2.7,0,0,1,1.09.27C3191,194,3191.92,195.44,3191.55,196.46Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3197.37,203.06a3.78,3.78,0,0,1-2.11,1.64,1,1,0,0,1-.48-.25c-.73-.7-.49-2.45.53-3.92a5.68,5.68,0,0,1,3-1.79C3198.3,199.35,3198.26,201.78,3197.37,203.06Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3192.06,204.39a1.37,1.37,0,0,1-1.12.73,3.86,3.86,0,0,1-1.69-.64c-1.42-.91-2.27-3.75-2.27-3.75a9,9,0,0,1,1.52-.22h.05a3.54,3.54,0,0,1,1.76.47C3191.73,201.9,3192.51,203.43,3192.06,204.39Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3192,184.3a3.33,3.33,0,0,1-1.52,2.51c-.76-.29-1.11-1.72-.82-3.28a6.14,6.14,0,0,1,1.73-2.75A7.11,7.11,0,0,1,3192,184.3Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3189.44,189a1.68,1.68,0,0,1-1.62,1.16,5.22,5.22,0,0,1-.63-.11c-1.38-.37-2.69-2.51-2.69-2.51a6.76,6.76,0,0,1,2.52-.95l.24,0C3188.65,187,3189.62,188.05,3189.44,189Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3187.6,178a2.85,2.85,0,0,1-1.1,2.43c-.58-.28-1-1.36-.9-2.62a5.55,5.55,0,0,1,1.14-2.61A5.69,5.69,0,0,1,3187.6,178Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3186.22,182.79c0,.72-.79,1.26-1.77,1.35a5.25,5.25,0,0,1-2.54-1.72,5.73,5.73,0,0,1,2.35-1.29C3185.4,181.28,3186.27,182,3186.22,182.79Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3183.8,178.45a1,1,0,0,1-.73.5,3.08,3.08,0,0,1-1.26-.53c-1.06-.74-1.64-2.91-1.64-2.91a5.47,5.47,0,0,1,.93-.11,2.84,2.84,0,0,1,1.46.41C3183.61,176.55,3184.17,177.73,3183.8,178.45Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3139.46,220.32c-.37,1.07-1.88,1.3-3.38.52l-.17-.1c-1.4-.89-2.42-3.53-2.42-3.53a6.14,6.14,0,0,1,3.67-.33l.27.11C3138.92,217.77,3139.83,219.26,3139.46,220.32Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3144.57,217.9c-.93,1.61-2.33,2.38-3.1,1.71l0-.06c-.72-.73-.56-2.52.36-4.08a5.85,5.85,0,0,1,2.91-2.13c.33-.12.55-.18.55-.18S3145.52,216.28,3144.57,217.9Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3143.86,226.5c-.22,1.13-1.67,1.68-3.26,1.23a2.38,2.38,0,0,1-.7-.34,9.25,9.25,0,0,1-2.36-2.68s2.26-1.51,3.84-1.06l.47.16C3143.18,224.36,3144.05,225.49,3143.86,226.5Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3148.75,222.67c-.37,1.93-1.41,3.28-2.34,3a1,1,0,0,1-.42-.25c-.63-.61-.89-2.11-.59-3.72a7.54,7.54,0,0,1,2.14-3.42l.34-.33S3149.12,220.74,3148.75,222.67Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3135.9,211.82c-.45.84-1.65.87-2.86.15h0a4,4,0,0,1-.51-.36c-1.35-1.09-2-4.14-2-4.14a6.92,6.92,0,0,1,3.13.21,2.71,2.71,0,0,1,.78.43C3135.74,209.19,3136.42,210.85,3135.9,211.82Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3142.79,207.13s-.57,3.07-1.89,4.23c-1.16,1-2.47,1.27-3.14.67a.94.94,0,0,1-.24-.28c-.56-.95.07-2.64,1.38-3.8a4.93,4.93,0,0,1,3.25-.86C3142.54,207.1,3142.79,207.13,3142.79,207.13Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3136.54,193.93a1.16,1.16,0,0,1-1.25-.23,4.81,4.81,0,0,1-1.48-2.26c-.58-1.67.05-4.27.17-4.74a.17.17,0,0,0,0-.07s2.34,1.34,3,3.17S3137.4,193.47,3136.54,193.93Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3143.74,191.66s-1.1,2.84-2.59,3.61a2.82,2.82,0,0,1-3,.09,1.3,1.3,0,0,1-.44-.61c-.36-1.06.55-2.55,2-3.33a4.84,4.84,0,0,1,3.32,0C3143.5,191.56,3143.74,191.66,3143.74,191.66Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3135.12,203.13c-.44.43-1.12.38-1.83-.08a4.7,4.7,0,0,1-1.36-1.38c-1-1.54-.92-4.68-.92-4.68a8.22,8.22,0,0,1,1.63.54,4.59,4.59,0,0,1,2,1.49C3135.62,200.56,3135.85,202.4,3135.12,203.13Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3142.93,199.24s-.85,3-2.27,3.92c-1.16.78-2.38.9-3,.36a1.19,1.19,0,0,1-.35-.45c-.46-1,.32-2.61,1.74-3.57a4.91,4.91,0,0,1,3.31-.4C3142.69,199.17,3142.93,199.24,3142.93,199.24Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3139.32,184.67a1,1,0,0,1-.89-.28,4.22,4.22,0,0,1-1.14-2.39,8,8,0,0,1,.7-3.9,1.08,1.08,0,0,1,.08-.2,7.19,7.19,0,0,1,2.14,3.3C3140.53,182.89,3140.13,184.44,3139.32,184.67Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3145.42,185.38s-1.31,2.25-2.7,2.63a2.73,2.73,0,0,1-2.31-.27,1.29,1.29,0,0,1-.53-.82c-.18-1,.79-2.1,2.18-2.49a3.77,3.77,0,0,1,2.3.37A7.72,7.72,0,0,1,3145.42,185.38Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3143.16,178a.8.8,0,0,1-.64-.29,3.69,3.69,0,0,1-.8-2.33,6.49,6.49,0,0,1,1-3.1l.16-.28a6.76,6.76,0,0,1,1.47,3.17C3144.4,176.71,3143.88,178,3143.16,178Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3148,180s-1.37,1.7-2.61,1.8a2.55,2.55,0,0,1-1.71-.42,1.32,1.32,0,0,1-.6-1c0-.88.92-1.67,2.15-1.77a2.37,2.37,0,0,1,1,.18A6.7,6.7,0,0,1,3148,180Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3149.76,172.78s-.59,2.28-1.65,3.05-1.92.78-2.4.28a.94.94,0,0,1-.18-.25c-.37-.75.19-2,1.25-2.76a3.48,3.48,0,0,1,2.34-.42A3.89,3.89,0,0,1,3149.76,172.78Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3138.88,220c-.34,1-1.62,1.24-3,.7-1.4-.89-2.42-3.53-2.42-3.53a6.14,6.14,0,0,1,3.67-.33C3138.47,217.68,3139.23,219,3138.88,220Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3144,217.61c-.76,1.3-1.8,2-2.58,1.94-.72-.73-.56-2.52.36-4.08a5.85,5.85,0,0,1,2.91-2.13A9.2,9.2,0,0,1,3144,217.61Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3143.28,226.21c-.21,1.13-1.67,1.68-3.25,1.23a.35.35,0,0,1-.13-.05,9.25,9.25,0,0,1-2.36-2.68s2.26-1.51,3.84-1.06l.47.16A2.52,2.52,0,0,1,3143.28,226.21Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3148.17,222.38c-.34,1.83-1.3,3.14-2.18,3.06-.63-.61-.89-2.11-.59-3.72a7.54,7.54,0,0,1,2.14-3.42A8.68,8.68,0,0,1,3148.17,222.38Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3135.33,211.54c-.38.7-1.3.84-2.29.43h0a4,4,0,0,1-.51-.36c-1.35-1.09-2-4.14-2-4.14a6.92,6.92,0,0,1,3.13.21l.2.14C3135.17,208.9,3135.85,210.56,3135.33,211.54Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3142.15,207.09c-.16.76-.73,3-1.82,4a3.19,3.19,0,0,1-2.57,1,.94.94,0,0,1-.24-.28c-.56-.95.07-2.64,1.38-3.8A4.93,4.93,0,0,1,3142.15,207.09Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3136,193.64a1,1,0,0,1-.67.06,4.81,4.81,0,0,1-1.48-2.26c-.58-1.67.05-4.27.17-4.74a6.66,6.66,0,0,1,2.41,2.81C3137,191.34,3136.83,193.18,3136,193.64Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3143.13,191.45c-.2.48-1.22,2.84-2.56,3.54a3.39,3.39,0,0,1-2.37.37,1.3,1.3,0,0,1-.44-.61c-.36-1.06.55-2.55,2-3.33A4.84,4.84,0,0,1,3143.13,191.45Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3134.54,202.84a1.16,1.16,0,0,1-1.25.21,4.7,4.7,0,0,1-1.36-1.38c-1-1.54-.92-4.68-.92-4.68a8.22,8.22,0,0,1,1.63.54,4.06,4.06,0,0,1,1.37,1.2C3135,200.27,3135.28,202.11,3134.54,202.84Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3142.31,199.1c-.2.63-1,3-2.23,3.77a3.25,3.25,0,0,1-2.47.65,1.19,1.19,0,0,1-.35-.45c-.46-1,.32-2.61,1.74-3.57A4.91,4.91,0,0,1,3142.31,199.1Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3138.74,184.38a.8.8,0,0,1-.31,0,4.22,4.22,0,0,1-1.14-2.39,8,8,0,0,1,.7-3.9,6.36,6.36,0,0,1,1.65,2.8C3140,182.6,3139.55,184.16,3138.74,184.38Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3144.85,185.1s-1.32,2.24-2.7,2.62a3.12,3.12,0,0,1-1.74,0,1.29,1.29,0,0,1-.53-.82c-.18-1,.79-2.1,2.18-2.49a3.77,3.77,0,0,1,2.3.37Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3142.59,177.74h-.07a3.69,3.69,0,0,1-.8-2.33,6.49,6.49,0,0,1,1-3.1,5.69,5.69,0,0,1,1,2.61C3143.82,176.43,3143.31,177.69,3142.59,177.74Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3147.44,179.75s-1.37,1.69-2.6,1.79a2.8,2.8,0,0,1-1.14-.13,1.32,1.32,0,0,1-.6-1c0-.88.92-1.67,2.15-1.77a2.37,2.37,0,0,1,1,.18A6.76,6.76,0,0,1,3147.44,179.75Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3149.12,172.68a6.16,6.16,0,0,1-1.58,2.86,2.52,2.52,0,0,1-1.83.57.94.94,0,0,1-.18-.25c-.37-.75.19-2,1.25-2.76A3.48,3.48,0,0,1,3149.12,172.68Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "56.64 0 38.86 85.73 41.78 85.73 61.86 0 56.64 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "61.86 0 41.78 85.73 45.61 85.73 67.88 0 61.86 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "67.88 0 45.61 85.73 47.23 85.73 73.15 0 67.88 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "67.88 0 45.61 85.73 47.23 85.73 73.15 0 67.88 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3203.58,201.18a38.57,38.57,0,0,1-38.53,38.52q-1.58,0-3.12-.12a38.61,38.61,0,0,1-32.25-23.13c57.17,13.35,53.85-39.13,52.83-48.44a5,5,0,0,0,.24-1,37.37,37.37,0,0,1,16.17,15.87A38.26,38.26,0,0,1,3203.58,201.18Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M3203.58,201.18a38.57,38.57,0,0,1-38.53,38.52q-1.58,0-3.12-.12c26.14-9.06,34.05-36.9,36.44-52.62l1.77-1.69A36.09,36.09,0,0,1,3203.58,201.18Z",
    transform: "translate(-3121.02 -71.75)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M3194.52,230.09a41.41,41.41,0,0,1-7.31,5.93l-.47-1.83-.25-1-2.15.26-5.07-4.59-50-42-1.12-4.24-3.66,1.2a8.36,8.36,0,0,0,.51-1.16c.31-.67.64-1.34,1-2a39.6,39.6,0,0,1,3-4.83l4.34-1.08.22,4.25,48.4,39.77,1.36,1.24v0h0l1.92,1.75,2.71,2.45h0l2.6,2.37.32.27.43.4h2l.16.43Z",
    transform: "translate(-3121.02 -71.75)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M3200,223.18a37.63,37.63,0,0,1-2.73,3.8l-1.12-2.91-.05-.12h-2.16l-57.34-48.74-.42-3.56-3.87.15.44-.46c.48-.5,1-1,1.48-1.45.36-.34.74-.68,1.12-1l4.37-.33,0,3.46,56,47.25.7.65,2.06-.07h.27Z",
    transform: "translate(-3121.02 -71.75)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.3905a5a512077411c2c2dc6ceec3f122.svg";
export { ForwardRef as ReactComponent };